import { ConfirmationData } from '@/features/book-appointment/booking.types';

type EncodedSessionData = ConfirmationData | null;

type setOptions = {
  key: string;
  itemKey?: string;
  data: unknown;
};

type getOptions = {
  key: string;
  itemKey?: string;
};

type EncodedSessionStorage = {
  setToStorage: (options: setOptions) => void;
  getFromStorage: (options: getOptions) => ConfirmationData | null;
};

// Naive base64 encoding for storage, do not use for sensitive data
const encode = (data: unknown) => {
  return btoa(JSON.stringify(data));
};

const decode = (data: string) => {
  return atob(data);
};

export const decodeItem = (item: { value: string }): EncodedSessionData | null => {
  if (!item || !item.value) return null;
  return JSON.parse(decode(item.value)) as EncodedSessionData;
};

export const getFromStorage = ({ key, itemKey }: getOptions): EncodedSessionData | null => {
  const storedValue = JSON.parse(sessionStorage.getItem(key) || 'null');
  if (!storedValue) return null;

  const result = itemKey ? decodeItem(storedValue[itemKey]) : decodeItem(storedValue);
  return result;
};

export const useSessionStorageWithCollection = (): EncodedSessionStorage => {
  const setToStorage = ({ key, itemKey, data }: setOptions) => {
    const encodedValue = encode(data);

    if (!itemKey) {
      // No itemKey: store directly under main key
      const item = encodedValue;
      sessionStorage.setItem(key, JSON.stringify(item));
    } else {
      // itemKey provided: store as part of a collection under main key
      const existing = sessionStorage.getItem(key);
      let collection: Record<string, { value: string }> = {};

      if (existing && isJsonString(existing)) {
        collection = JSON.parse(existing);
      }

      collection[itemKey] = {
        value: encodedValue,
      };

      sessionStorage.setItem(key, JSON.stringify(collection));
    }
  };

  const isJsonString = (str: string) => {
    try {
      JSON.parse(str);
      // eslint-disable-next-line
    } catch (e) {
      return false;
    }
    return true;
  };

  return {
    setToStorage,
    getFromStorage,
  };
};
